import { Autocomplete, GoogleMap, StandaloneSearchBox } from "@react-google-maps/api";
import React, { useRef } from "react";
import { dispatch } from "../../dispatcher/Dispatcher";
import MapEvent from "../../events/MapEvent";
import UIFlex, { copyFlex, IUIFlexProps } from "../UIFlex";
import './UIMap.scss';
export interface IUIMapProps extends IUIFlexProps{
    onMapLoaded?:($map:google.maps.Map)=>void;
    mapContainerStyle?:React.CSSProperties;
    zoom?:number;
    center?:google.maps.LatLng | google.maps.LatLngLiteral;
    options?:google.maps.MapOptions;
    onZoomChanged?:()=>void;
    onUnmount?:()=>void;
    onDragStart?:()=>void;
    onProjectionChanged?:()=>void;
    onMapClick?:($event:google.maps.MapMouseEvent)=>void;
}

const UIMap = React.forwardRef<UIFlex, IUIMapProps>(($props, $ref)=>{

    let flex = copyFlex({fullWidth:true},$props.flex);


    const _onMapLoaded = ($map:google.maps.Map)=>{
        if($props.onMapLoaded){
            $props.onMapLoaded($map);
        }
        $map.setTilt(0);
    }

    const _onZoomChange=()=>{
        if($props.onZoomChanged){
            $props.onZoomChanged();
        }
        dispatch(MapEvent.CHANGE);
    }
    const _onDragStart=()=>{
        if($props.onDragStart){
            $props.onDragStart();
        }
    }
    const _onProjectionChanged=()=>{
        if($props.onProjectionChanged){
            $props.onProjectionChanged();
        }
    }

    let cn:string = "uiMap";
    if($props.className){
        cn+=" "+$props.className;
    }

    return (
        <UIFlex flex={flex} className={cn} ref={$ref}>
            <GoogleMap
                onLoad={_onMapLoaded}
                mapContainerClassName={"uiMapContainer"}
                mapContainerStyle={$props.mapContainerStyle}  
                clickableIcons={false}
                zoom={$props.zoom}
                center={$props.center}
                options={$props.options}
                onZoomChanged={_onZoomChange}
                onDragStart={_onDragStart}
                onProjectionChanged={_onProjectionChanged}
                onUnmount={$props.onUnmount}
                onClick={$props.onMapClick}
            >
                {$props.children}       
            </GoogleMap>
        </UIFlex>
    );
});
export default UIMap;
